import classNames from "classnames"
import { Button } from "primereact/button"
import { Dialog } from "primereact/dialog"
import { useEffect, useState } from "react"
import { FaArrowLeft, FaCheck } from "react-icons/fa"
import { useInfo } from "../../../context/infoContext"
import { Api } from "../../../services/api"
import { formatCurrency } from "../../../utils/formatCurrency"
import AcceptPropostaDialog from "./acceptPropostaDialog"
import { statusBodyTemplate } from "./propostaStatusBody"

function ContraPropostaRetornoDialog({ infoPropostas, close, accept }) {

    const { providerInfo } = useInfo()
    const [cobrancas, setCobrancas] = useState();
    const [valorTotal, setValorTotal] = useState(0);
    const [valorProposta, setValorProposta] = useState();
    const [valorFeePagueProposta, setValorFeePagueProposta] = useState(0);
    const [valorFeeProtestoProposta, setValorFeeProtestoProposta] = useState(0);
    const [feeProporcional, setFeeProporcional] = useState(0)
    const [propostaParcelas, setPropostaParcelas] = useState();
    const [propostaValorEntrada, setPropostaValorEntrada] = useState();
    const [mostraConfirmacao, setMostraConfirmacao] = useState(false);
    const [negotiateInfo, setNegotiateInfo] = useState([]);

    const footer = (
        <div className="flex justify-center gap-2 w-full">
            <Button
                label='Confirmar'
                icon={<FaCheck className="mr-2"/>}
                severity="success"
                disabled={infoPropostas.pnmt_situacao !== "APROVADA"}
                onClick={() => criaDataNegociacao()}
            />
            <Button
                label="Voltar"
                icon={<FaArrowLeft className="mr-2"/>}
                severity="danger"
                onClick={() => close()}
            />
        </div>
    )


    function criaDataNegociacao() {
        const data = {
            cobrancas,
            proposta_id: infoPropostas.pnmt_id,
            acao: 'ACEITAR',
            valorTotal: valorTotal,
            desconto: valorTotal - valorProposta,
            valorAPagar: valorProposta,
            valorProtesto: valorFeeProtestoProposta,
            valorPague: valorFeePagueProposta,
            valorProvider: valorProposta - valorFeeProtestoProposta - valorFeePagueProposta,
            parcelas: propostaParcelas,
            fee_proporcional: feeProporcional,
            entrada: propostaValorEntrada,
            justificativa: '',
            mensagem_dialog: 'Confirme os dados da negociação a ser gerada',
            fee_plataforma: 2.9,
        }
        setNegotiateInfo(data)
        setMostraConfirmacao(true)
    }

    useEffect(() => {
        const getCobrancaData = async () => {
            try {
                // console.log(infoPropostas)
                const { data } = await Api.get(`/propostas/listarDetalhes/${infoPropostas.pnmt_id}`)
                //setTotal(data.count)
                setCobrancas(data.cobrancas)
                setValorTotal(parseFloat(data.acumulado_propostas.valor_total))
                proporcionalFeeProtesto(parseFloat(data.acumulado_propostas.valor_total), parseFloat(data.acumulado_propostas.valor_fee), infoPropostas.pnmt_valor_proposta, infoPropostas.pnmt_valor_qtd_parcelas, infoPropostas.pnmt_valor_entrada)
            } catch (error) {
                console.log(error)
            }
        }
        function setPropostaInfo() {
            setValorProposta(infoPropostas.pnmt_valor_proposta);
            setPropostaParcelas(infoPropostas.pnmt_valor_qtd_parcelas);
            setPropostaValorEntrada(infoPropostas.pnmt_valor_entrada);
        }

        function proporcionalFeeProtesto(valor_total, valor_fee, valor_proposta, parcela, entrada) {
            const parcela_c_entrada = entrada > 0 ? parcela + 1 : parcela
            const fee_plataforma = 2.9
            const porcentagem_fee = valor_fee / valor_total
            const valor_s_fee_pague = (((valor_proposta / parcela_c_entrada) * 0.99) - fee_plataforma) * parcela_c_entrada
            const fee_proposta = valor_s_fee_pague * porcentagem_fee
            console.table({ fee_plataforma, porcentagem_fee, valor_s_fee_pague, fee_proposta, valor_total, valor_proposta, valor_fee })
            setFeeProporcional(porcentagem_fee)
            setValorFeePagueProposta(valor_proposta - valor_s_fee_pague)
            setValorFeeProtestoProposta(fee_proposta)
        }

        getCobrancaData()
        setPropostaInfo()
    }, [])


    return (
        <Dialog
            visible
            onHide={() => close()}
            header="Contra-Proposta Status"
            footer={footer}
            pt={{
                root: 'max-w-screen lg:max-h-[80vh]',
                headerTitle: 'font-bold text-xl w-full text-center',
                content: ({ state }) => ({
                    className: classNames('overflow-auto w-full max-h-[80vh]',
                        'bg-white text-gray-700 px-6 pb-8 pt-0',
                        //'rounded-bl-lg rounded-br-lg',
                        'dark:bg-gray-900 dark:text-white/80 ', {
                        "grow": state.maximized
                    })
                }),
            }}
        >
            {mostraConfirmacao &&
                <AcceptPropostaDialog
                    close={() => setMostraConfirmacao(false)}
                    negotiateInfo={negotiateInfo}
                    accept={() => { accept(negotiateInfo) }}
                />}
            <div className="text-center grid gap-4">
                <h4><b>Estado da Contra-Proposta</b></h4>
                <div className="border-2 dark:bg-rose-900 bg-rose-100 p-4" >
                    <h5><b>Valor Contra-Proposta:</b> {formatCurrency(infoPropostas.pnmt_valor_proposta)}</h5>
                    {infoPropostas.pnmt_valor_entrada > 0 && <h5><b>Entrada:</b> {formatCurrency(infoPropostas.pnmt_valor_entrada)}</h5>}
                    <h5><b>Número de Parcelas:</b> {infoPropostas.pnmt_valor_entrada > 0 && '1 + '} {infoPropostas.pnmt_valor_qtd_parcelas}</h5>
                    <h5><b>Justificativa:</b> {infoPropostas.pnmt_justificativa}</h5>
                    <h5><b>Status:</b></h5>
                    {statusBodyTemplate(infoPropostas)}
                </div>
            </div>
        </Dialog>
    )
}

export default ContraPropostaRetornoDialog